import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Select, Button, Row, Col } from 'hljd'
import store from './store'
import myStore from '../store'
import { observer } from 'mobx-react'
import { getYears } from '@components/Hotel/util'

const Item = Form.Item
const Option = Select.Option

@observer
export default class extends Component {
  componentDidUpdate() {
    store.search()
  }
  handleSetBanquetHall = value => {
    store.setBanquetHall(value)
  }
  handleSetYear = value => {
    store.setYear(value)
  }
  handleSetMonths = value => {
    store.setMonths(value)
  }
  handleSearch = () => {
    store.search()
  }
  handleRest = () => {
    store.reset()
  }
  render() {
    const { entity_id, year, months } = store
    const { hotelHalls } = myStore
    const years = getYears()
    let allHotelHalls = hotelHalls.map(item => (
      <Option value={item.id} key={item.id}>
        {item.name}
      </Option>
    ))
    let allYears = years.map((item, key) => (
      <Option value={item} key={key}>
        {item}
      </Option>
    ))
    return (
      <Form
        layout="inline"
        style={{
          padding: '20px 20px 20px 0',
          border: '1px solid #e7e7e7',
          marginTop: 20
        }}
      >
        <Row>
          <Col span={6} style={{ textAlign: 'right' }}>
            <Item label="宴会厅">
              <Select
                style={{ width: 120, textAlign: 'left' }}
                value={entity_id}
                onChange={this.handleSetBanquetHall}
              >
                <Option value={''}>全部</Option>
                {allHotelHalls}
              </Select>
            </Item>
          </Col>
          <Col span={6} style={{ textAlign: 'right' }}>
            <Item label="年份">
              <Select
                style={{ width: 120, textAlign: 'left' }}
                value={year}
                onChange={this.handleSetYear}
              >
                {allYears}
              </Select>
            </Item>
          </Col>
          <Col span={6} style={{ textAlign: 'right' }}>
            <Item label="月份">
              <Select
                style={{ width: 120, textAlign: 'left' }}
                value={months}
                onChange={this.handleSetMonths}
              >
                <Option value={'1'}>1-3月</Option>
                <Option value={'2'}>4-6月</Option>
                <Option value={'3'}>7-9月</Option>
                <Option value={'4'}>10-12月</Option>
              </Select>
            </Item>
          </Col>
          <Col span={6}>
            <Item style={{ margin: '0 20px' }}>
              <Button
                style={{ width: 80, height: 30 }}
                type="primary"
                onClick={this.handleSearch}
              >
                查询
              </Button>
              <Button
                style={{ marginLeft: 14, width: 80, height: 30 }}
                onClick={this.handleRest}
              >
                重置
              </Button>
            </Item>
          </Col>
        </Row>
      </Form>
    )
  }
}
